import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

// NOTE: This project ships a pre-compiled, frozen Tailwind stylesheet (src/index.css)
// with no Tailwind build step, so utility classes that weren't already used elsewhere
// (e.g. the switch's data-[state] variants and arbitrary sizes) have no CSS and render
// invisibly. To stay robust regardless of the frozen CSS, the switch is styled with
// inline styles driven by the controlled `checked` prop (all usages are controlled).
function Switch({
  className,
  checked,
  disabled,
  style,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  const isOn = checked === true;

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      checked={checked}
      disabled={disabled}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        height: "1.25rem",
        width: "2.25rem",
        flexShrink: 0,
        borderRadius: "9999px",
        border: "1px solid transparent",
        padding: "2px",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "background-color .2s ease",
        backgroundColor: isOn ? "var(--primary, #0f1f3d)" : "var(--switch-background, #cbced4)",
        ...style,
      }}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        style={{
          display: "block",
          height: "1rem",
          width: "1rem",
          borderRadius: "9999px",
          backgroundColor: "#ffffff",
          boxShadow: "0 1px 2px rgba(0,0,0,.25)",
          transition: "transform .2s ease",
          transform: isOn ? "translateX(1rem)" : "translateX(0)",
        }}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
